module.exports = __webpack_public_path__ + "img/lists_section.8520a93b.png";